import { render } from "./CardCom.vue?vue&type=template&id=21ba5eae&scoped=true"
const script = {}

import "./CardCom.vue?vue&type=style&index=0&id=21ba5eae&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ba5eae"]])

export default __exports__